export enum PageListType {
  /**
   * A two-column grid of rectangular tiles with vertical scrolling.
   *
   * If a list item is also a list (nested list), opening it will
   * display a separate page in the same style, displaying the items
   * of the nested list.
   */
  Standard = 'standard',

  /**
   * A combined display method where nested lists are displayed
   * simultaneously on the same page.
   *
   * All nested lists are shown first.
   * Each nested list is expanded into a horizontal sequence of tiles,
   * with a common header above them. Four items fit on the screen in
   * a single row.
   *
   * Then all regular items are shown as a horizontal sequence of
   * rectangular tiles. The tiles here are x2 larger, two per row.
   */
  Hub = 'hub',

  /**
   * Left sidebar with navigation links. List items on the right.
   * Supports nested lists.
   */
  Classic = 'classic',
}
